import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages ;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};

export const messagesZHHK: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    privacyPolicy: '隱私政策',
    schoolName: '學校',
    infoShared1: ' ',
    informationTransferredToUS: ' ',
    infoShared2: '在此處輸入之資訊將用於驗證目的，並與{companyName}共享。',
    optIn: `點擊即表示本人同意按照 <a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">SheerID隱私政策</a> 和 <a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">Lenovo隱私政策</a>. 中所述驗證本人之資格。本人了解所提供之個人資料將與Lenovo共享。本人之資料將被轉移到美國並參照SheerID的隱私政策和Lenovo的隱私聲明來處理。`,
    requestSchool: '沒有您的學校嗎？請求新增。',
    countries: {
        HK: '香港特別行政區',
        TW: '台灣',
    },
    step: {
        personalInfo: {
            title: '解鎖學生專屬優惠',
        },
        docUpload: {
            title: '我們需要您的身分驗證資訊以及相關學生證明',
            subtitle: '該文件將由SheerID員工於半小時內進行驗證。SheerID 的員工以 半小时 的形式審核。',
        },
        success: {
            title: '您已通過驗證',
            subtitle: '您的折扣將自動於您的購物車中顯示，請點擊下面的按鈕繼續購物。',
            emailNotification: '我們已通過verify@sheerid.com 發送此連結至您的電子郵箱，以便您繼續購物。',
            redirectButtonText: '繼續購物',
            redirect: '繼續購物',
        },
        emailLoop: {
            title:'檢視您的電郵。',
            subtitleWithEmail:'已向 {email} 寄出電子郵件。請使用郵件中的個人連結完成驗證。',
            subtitleWithoutEmail:'已向您的電子郵箱寄出電子郵件。請使用郵件中的個人連結完成驗證。',
            subtitle2:'請參閱我們寄出的電子郵件（verify@sheerid.com）獲取詳細資訊。',
            successResend:'電子郵件已成功重新發送。',
            resendButton:'重新發送',
            errors:{
                resend:'發送電郵時出錯',
            },
            skipEmail:'無法找回此電子郵件？點擊',
            skipEmailCTA:'這裡',
            skipEmail2:'繼續。'
        },
        pending: {
            turnaroundTime: "處理時間通常約為{estReviewTime}；在極少數的情況下，能需要最多{maxReviewTime}。",
            subtitle3: "我們將以電子郵件聯絡您。",
        },
    },
};
